let language = {

    "STORE_EMAIL_SETTING_FAIL_TO_RETRIEVE_EMAIL_SETTING_TITLE": "Failed to retrieve store email settings",
    // 当前用户与storeId不匹配
    "A121B001": "Current user does not match the store.",
    
    "STORE_EMAIL_SETTING_FAIL_SEND_EMAIL_TITLE": "Failed to send email",
    // 连接失败
    "A121B002": "SMTP server connection failed, please check your SMTP server config and retry again later.",
    // 授权错误
    "A121B003": "Server authorization failed, please check your email address or password to ensure it is correct.",
    // 发送失败
    "A121B004": "SMTP Server failed to send mail",

};

export { language }